/*
 * The texts of the events extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		event: {
			create: 'Create event',
			edit: 'Edit event',
			settings: 'Event settings',
			enable: 'Enable event',
			lock: 'Lock event',
		},
		// The teams of an event, in its settings
		event_team: {
			add: 'Add team',
			remove: 'Remove team',
		},
	},
	pages: {
		admin: {
			events: {
				title: 'Events',
				create: 'Create event',
				edit: 'Edit event',
				teams: 'Teams',
			},
		},
		settings: {
			events: {
				title: 'Events',
			},
		},
	},
	sidebar: {
		events: 'Events',
	},
	modals: {
		admin: {
			edit_event: {
				create: 'Create new event',
				edit: 'Edit event',
				users: 'People',
				teams: 'Teams',
			},
		},
		invite_team: {
			title: 'Add team',
		},
	},
	data: {
		event: {
			id: 'Id',
			name: 'Name',
			prefix: 'Prefix',
			start_at: 'Start',
			end_at: 'End',
			show_start_at: 'Event start',
			show_end_at: 'Event end',
			is_locked: 'Locked',
			enabled: 'Enabled',
			teams_count: '# Teams',
			users_count: '# People',
			preferred_crs: 'Preferred coordinate system',
			coordinates: 'Coordinates',
			inital_coordinates: 'Initial coordinates',
		},
	},
	notifications: {
		assigned_to_event: {
			icon: 'fa-campground',
			title: 'Added to event',
			text: "You have been added to the event '{event_name}'.",
		},
	},
	enums: {
		event_state: {
			active: 'Active',
			inactive: 'Inactive',
		},
	},
	components: {
		// The switcher's group of the user's other records of this kind
		header_context: {
			own_event: 'Your other events',
		},
		// efOccupiedDaysNote
		occupied_days: {
			note: 'Something at the event lies on the days from {first} to {last}. The dates have to include these days.',
		},
	},
	contexts: {
		event: 'Event',
	},
	tabs: {
		context_settings: {
			teams: 'Teams',
			events: 'Events',
		},
	},
	confirms: {
		remove_team_from_event: {
			title: 'Remove team',
			text: "Should the team '{team}' no longer take part in '{event}'?",
		},
	},
};
